export class Slider {
    private slider:HTMLInputElement;
    public container: HTMLElement;
    private defaultValue:number;
    private label:HTMLElement;
    private valueElement:HTMLSpanElement;
    private listener: () => any;
    private labelPrinter: (val:number) => any;
    public get value(): number {
        return Number(this.slider.value);
    } 
    constructor(id: string, labelText:string, min:number, max:number, defaultValue:number,listener: () => any, labelPrinter:(val:number) => any) {
      this.defaultValue = defaultValue;
      this.slider = this.createSlider(id,min,max,defaultValue);
      this.container = document.createElement("div") as HTMLElement;
      this.container.style.display="flex";
      this.label = document.createElement("label"); 
      this.label.style.width =  `60%`
      this.label.style.fontSize = '10px'
      this.label.textContent = labelText+": ";
      this.listener = listener;
      this.labelPrinter = labelPrinter;
      let resetBut = document.createElement("button");
      resetBut.classList.add("slider-reset-button");
      resetBut.textContent = "R";
      resetBut.addEventListener("click",()=>{
        this.setToDefault();
      })
      this.valueElement = document.createElement("span");
      this.valueElement.textContent = this.labelPrinter(Number(this.slider.value));
      this.slider.addEventListener("input", () => {
        this.valueElement.textContent = this.labelPrinter(Number(this.slider.value));
          this.listener();
      });
      this.label.appendChild(resetBut);
      this.label.appendChild(this.valueElement);
      this.container.appendChild(this.label);
      this.container.appendChild(this.slider);
    }
    public setToDefault(){
        this.slider.value = String(this.defaultValue);
        this.valueElement.textContent = this.labelPrinter(Number(this.slider.value));
        this.listener();
    }
    private createSlider(id: string, min: number, max: number, value: number): HTMLInputElement {
        const input = document.createElement("input");
        input.type = "range";
        input.id = id;
        input.min = String(min);
        input.max = String(max);
        input.value = String(value);
        input.style.width="40%"
        return input;
    }
    public changeValue(value:number){
        this.slider.value = String(value);
        this.valueElement.textContent = this.labelPrinter(Number(this.slider.value));
        this.listener();
    }
    public destroy(){
      this.slider.innerHTML = "";
      this.label.innerHTML = "";
      this.valueElement.innerHTML = "";
      this.label.removeChild(this.valueElement);
      this.container.removeChild(this.slider);  
      this.container.removeChild(this.label);    
      this.container.innerHTML = "";
      this.container.style.marginLeft = "0px";
      this.container.style.marginTop = "0px";
    }
}